"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickCaptureService = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importStar(require("./Logger"));
class ClickCaptureService {
    // Utility for dealing with Record<string, string> component facets
    decodeAttribute(name) {
        const regexMatch = this.htmlAttributeRegex.exec(name);
        if (!regexMatch)
            return null;
        const facetKey = this.htmlAttributeMapping[regexMatch[1]];
        const propertyKey = regexMatch[2];
        return {
            facetKey,
            propertyKey,
        };
    }
    // Utility to automatically extract the component name from image elements ("alt" and "src" attributes)
    imageComponentName(element) {
        return element.getAttribute("alt") || element.getAttribute("src");
    }
    // Utility to automatically extract the component name from the "name" attribute
    namedComponentName(element) {
        return element.getAttribute("name");
    }
    // Utility to automatically extract the component name from the Element
    // Additional logic to adjust the extraction based on the input type
    inputComponentName(element) {
        var _a;
        const type = (_a = element.getAttribute("type")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        switch (type) {
            case "reset":
            case "submit": {
                return element.value;
            }
            case "image": {
                return this.imageComponentName(element);
            }
            default: {
                return this.namedComponentName(element);
            }
        }
    }
    // Utility to automatically extract the component name from the Element
    componentFacetNameFrom(element) {
        const adpComponentName = element.getAttribute(Common_1.HTML_ATTRIBUTE_COMPONENT_NAME);
        if (adpComponentName)
            return adpComponentName;
        const tagName = element.tagName.toLowerCase();
        switch (tagName) {
            case "input": {
                return this.inputComponentName(element);
            }
            // these elements are typically contain the "name" attribute and are used as inputs in forms
            case "select":
            case "textarea": {
                return this.namedComponentName(element);
            }
            case "img": {
                return this.imageComponentName(element);
            }
            default: {
                return element.textContent;
            }
        }
    }
    // Utility to automatically extract the component facet from the Element
    componentFacetFrom(element) {
        const { tagName } = element;
        const id = element.getAttribute(Common_1.HTML_ATTRIBUTE_COMPONENT_ID) || element.id;
        const type = element.getAttribute(Common_1.HTML_ATTRIBUTE_COMPONENT_TYPE) || tagName;
        const name = this.componentFacetNameFrom(element);
        const href = tagName.toLowerCase() === "a" && element.getAttribute("href");
        const partialFacet = element.getAttributeNames().reduce((partial, attributeName) => {
            const attributeInfo = this.decodeAttribute(attributeName);
            if (!attributeInfo)
                return partial;
            const { facetKey, propertyKey } = attributeInfo;
            const propertyValue = element.getAttribute(attributeName);
            if (facetKey in partial && propertyValue) {
                // eslint-disable-next-line no-param-reassign
                partial[facetKey][propertyKey] = propertyValue;
            }
            return partial;
        }, {
            attributes: href ? { href } : {},
            metrics: {},
        });
        return Object.assign(Object.assign(Object.assign(Object.assign({}, partialFacet), (id ? { id } : undefined)), (name ? { name } : undefined)), { type });
    }
    constructor(contextService) {
        this.contextService = contextService;
        // Utility for dealing with Record<string, string> component facets
        this.htmlAttributeMapping = {
            attribute: "attributes",
            metric: "metrics",
        };
        // Utility for dealing with Record<string, string> component facets
        this.htmlAttributeRegex = new RegExp(`${Common_1.HTML_ATTRIBUTE_COMPONENT_PREFIX}-(${Object.keys(this.htmlAttributeMapping).join("|")})-(.*)`);
        this.capture = this.capture.bind(this);
    }
    /** Adds the click event listener to the document event emitter */
    connect() {
        document.addEventListener("click", this.capture);
    }
    /** Removes the click event listener from the document event emitter */
    disconnect() {
        document.removeEventListener("click", this.capture);
    }
    /** Handles the emitted click events
     * Only handles if the event target is an Element
     * Only handles if the element has the "adp-click" attribute. Value is not checked.
     */
    capture(event) {
        if (!this.contextService.context.config.captureDocumentClickEvents) {
            return;
        }
        const trackedElement = event.target && event.target instanceof Element && event.target.hasAttribute(Common_1.HTML_ATTRIBUTE_CAPTURE_CLICK)
            ? event.target
            : null;
        if (!trackedElement) {
            Logger_1.default.debug("Clicked event does not satisfy conditions for capture.");
            return;
        }
        Logger_1.default.debug("Capturing click event.");
        this.contextService.tracker.track("CLICK_COMPONENT", this.componentFacetFrom(trackedElement));
    }
}
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "connect", null);
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "disconnect", null);
exports.ClickCaptureService = ClickCaptureService;
